import { Col, Row, message, Upload } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import CustomCard from '../../../components/Antd/Card';
import CustomButton from '../../../v2-components/Antd/Button';
import CustomTable from '../../../v2-components/Antd/Table';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomModal from '../../../v2-components/Antd/Modal';
import Loading from '../../../v2-components/Loading';
import { Service } from '../service';
import StatusCard from './components/StatusCard';
import TrackingProgress from './components/TrackingProgress';
import { dictionaryInformation } from './constants/dictionary-information.constant';
import { clientInfoAdapter } from './handle/client-info-adapter.handle';
import { generateClientColumns } from './handle/gererate-client-columns.handle';
import { generateDeliveryColumns } from './handle/generate-delivery-columns.handle';
import { generateOrderColumns } from './handle/generate-order-columns.handle';
import { generatePaymentColumns } from './handle/generate-payment-columns.handle';
import { generateProductColumns } from './handle/generate-product-columns.handle';
import { adaptDeliveryInfo } from './handle/delivery-info-adapter.handle';
import { adaptOrderInfo } from './handle/order-info-adapter.handle';
import { adaptPaymentInfo } from './handle/payment-info-adapter.handle';
import { adaptProducts } from './handle/products-adapter.handle';
import './style.scss';

export default function PreorderDetailPage() {
	console.log('Rendering PreorderDetailPage');
	const { id } = useParams();
	const [data, setData] = useState();
	const [isError, setError] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const { token, pharmacy } = GetLocalStorageValue('userInfo')
	const [products, setProducts] = useState([])
	const [voucherViewed, setVoucherViewed] = useState(false);
	const [voucherModalOpen, setVoucherModalOpen] = useState(false);
	const [voucherUrl, setVoucherUrl] = useState(null);
	const [voucherLoading, setVoucherLoading] = useState(false);
	const [currentPaymentTrackingId, setCurrentPaymentTrackingId] = useState(null);
	const [selectedFile, setSelectedFile] = useState(null);
	const [isUpdatingVoucher, setIsUpdatingVoucher] = useState(false);
	const [showUpdateSection, setShowUpdateSection] = useState(false);
	const [isVoucherImage, setIsVoucherImage] = useState(true);

	const status = data?.status_tracking;
	const statusNumber = data?.status_tracking?.status;
	const [reloadKey, setReloadKey] = useState(0);
	const voucherSignedUrl = data?.payment_tracking_detail?.voucher_signed_url


	const handleViewVoucher = (paymentTrackingId) => {
		if (!paymentTrackingId || !voucherSignedUrl) return;
		
		setCurrentPaymentTrackingId(paymentTrackingId);
		setShowUpdateSection(false);
		setSelectedFile(null);
		setVoucherUrl(voucherSignedUrl);
		setVoucherViewed(true);
		setVoucherModalOpen(true);
		setIsVoucherImage(true);
	};

	const handleFileSelect = (file) => {
		// Validate file type
		const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
		if (!validTypes.includes(file.type)) {
			message.error('Solo se permiten archivos JPG, PNG o PDF');
			return false;
		}

		// Validate file size (max 5MB)
		const maxSize = 5 * 1024 * 1024;
		if (file.size > maxSize) {
			message.error('El archivo no debe superar los 5MB');
			return false;
		}

		setSelectedFile(file);
		return false; // Prevent auto upload
	};

	const handleUpdateVoucher = async () => {
		if (!selectedFile || !currentPaymentTrackingId) {
			message.error('Debe seleccionar un archivo');
			return;
		}

		setIsUpdatingVoucher(true);
		try {
			// Step 1: Get the signed URL
			const updateResponse = await new Service().updatePaymentVoucher(currentPaymentTrackingId, token);
			console.log('Update voucher response:', updateResponse);

			if (!updateResponse?.signed_url) {
				throw new Error('No se recibió la URL de carga');
			}

			// Step 2: Upload the file to the signed URL
			await new Service().uploadToSignedUrl(updateResponse.signed_url, selectedFile);

			message.success('Comprobante actualizado exitosamente');
			
			// Reload the voucher
			setShowUpdateSection(false);
			setSelectedFile(null);
			setReloadKey(prev => prev + 1);
		} catch (error) {
			console.error('Error updating voucher:', error);
			message.error('Error al actualizar el comprobante');
		} finally {
			setIsUpdatingVoucher(false);
		}
	};

	const handleCancelUpdate = () => {
		setShowUpdateSection(false);
		setSelectedFile(null);
	};

	useEffect(() => {
		if (voucherModalOpen && voucherSignedUrl) {
			setIsVoucherImage(true);
			setVoucherUrl(voucherSignedUrl);
		}
	}, [voucherSignedUrl]);

	useEffect(() => {
		setIsLoading(true)
		console.log('Fetching data for purchase ID:', id);
		new Service().getPreorderDetail(id, token)
			.then((dataResponse) => {
				console.log('Data received for purchase ID:', dataResponse);
				setData(dataResponse);
				setIsLoading(false)
			})
			.catch((error) => {
				setIsLoading(false);
				setError(true);
			});
	}, [id, reloadKey]);



	if (isError) {
		return (
			<>
				<Row>
					<Col span={8}>
						<h2>Lo sentimos...</h2>
						<h3>{`La preorden N° ${id} no existe`} </h3>
						<Link to={'preorder?status=requested&page=1'}>Volver a pre-ordenes</Link>
					</Col>
				</Row>
			</>
		);
	}





	if (isLoading) {
		return <Loading />;
	}
	return (
		<div className="ph-tracking-order-detail-page-container">
			<Row justify="space-between" align="middle">
				<Col>
					<h2>{`Pre-orden N° ${data?.tracking_id}`} </h2>
					<Link to={'/preorder?status=PAYMENT_PENDING&page=1'}>Volver a pre-ordenes de entrega</Link>
				</Col>
			</Row>
			<Row>
				<Col span={12}>
					<TrackingProgress data={data} />
				</Col>
				<Col span={12}>
					<CustomCard >
						<StatusCard
							products={products}
							statusNumber={statusNumber}
              trx_id={data?.trx_id}
							status={status}
							quotationData={data}
							quotationId={id}
							voucherViewed={voucherViewed}						token={token}
						onApprovalSuccess={() => setReloadKey(prev => prev + 1)}						/>
					</CustomCard>
				</Col>
				<Col span={24} style={{ marginBottom: '25px' }}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].client}</h3>
					<CustomTable columns={generateClientColumns({ statusNumber, quotationId: id, token})} pagination={false} dataSource={clientInfoAdapter(data)} />
	
				</Col>
				{data?.purchase_detail?.info?.type_retirement === 'domicilio' && (
				<Col span={24} style={{ marginBottom: '25px' }}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].delivery}</h3>
					<CustomTable columns={generateDeliveryColumns()} pagination={false} dataSource={adaptDeliveryInfo(data)} />
				</Col>
				)}
				<Col span={24} style={{ marginBottom: '25px' }}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].order}</h3>
					<CustomTable columns={generateOrderColumns(pharmacy)} pagination={false} dataSource={adaptOrderInfo(data)} />
				</Col>
				<Col span={24} style={{ marginBottom: '25px' }}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].payment}</h3>
				<CustomTable columns={generatePaymentColumns(handleViewVoucher)} pagination={false} dataSource={adaptPaymentInfo(data)} />
				</Col>
				<Col span={24} style={{ marginBottom: '25px' }}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].products}</h3>
					<CustomTable columns={generateProductColumns()} pagination={false} dataSource={adaptProducts(data)} />
				</Col>
			</Row>

			<CustomModal 
				title="Comprobante de pago" 
				onCancel={() => {
					setVoucherModalOpen(false);
					setShowUpdateSection(false);
					setSelectedFile(null);
				}} 
				footer={null} 
				open={voucherModalOpen}
				width={800}
			>
				{voucherLoading ? (
					<Loading />
				) : voucherUrl ? (
					<div style={{ textAlign: 'center' }}>
						{isVoucherImage ? (
							<CustomImage
								src={voucherUrl}
								alt="Comprobante de pago"
								style={{ height: '40vh', objectFit: 'contain', width: '100%' }}
								onError={() => setIsVoucherImage(false)}
							/>
						) : (
							<object
								data={voucherUrl}
								type="application/pdf"
								style={{ width: '100%', height: '60vh', marginBottom: '20px' }}
							>
								<p>No se puede visualizar el comprobante.</p>
							</object>
						)}

						<div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>

							{data?.status === 'PAYMENT_PENDING' && !showUpdateSection && (
								<CustomButton
									type="default"
									onClick={() => setShowUpdateSection(true)}
								>
									Actualizar comprobante
								</CustomButton>
							)}
						</div>

						{showUpdateSection && data?.status === 'PAYMENT_PENDING' && (
							<div style={{
								marginTop: '30px',
								padding: '20px',
								border: '1px solid #d9d9d9',
								borderRadius: '4px',
								backgroundColor: '#fafafa'
							}}>
								<h4 style={{ marginBottom: '15px' }}>Actualizar comprobante de pago</h4>
								<Upload
									beforeUpload={handleFileSelect}
									maxCount={1}
									accept="image/jpeg,image/jpg,image/png,application/pdf"
									showUploadList={true}
									fileList={selectedFile ? [{
										uid: '-1',
										name: selectedFile.name,
										status: 'done',
									}] : []}
									onRemove={() => setSelectedFile(null)}
								>
									<CustomButton disabled={isUpdatingVoucher}>
										Seleccionar archivo
									</CustomButton>
								</Upload>
								<p style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
									Formatos permitidos: JPG, PNG, PDF (máx. 5MB)
								</p>

								<div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
									<CustomButton
										onClick={handleCancelUpdate}
										disabled={isUpdatingVoucher}
									>
										Cancelar
									</CustomButton>
									<CustomButton
										type="primary"
										onClick={handleUpdateVoucher}
										loading={isUpdatingVoucher}
										disabled={!selectedFile}
									>
										Actualizar
									</CustomButton>
								</div>
							</div>
						)}
					</div>
				) : (
					<p>No se pudo cargar el comprobante</p>
				)}
			</CustomModal>
		</div>
	);
}
